import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  Box,
  LinearProgress,
  Typography,
} from "@mui/material";
import {
  API_get_activities_simple,
  API_apply_message_for_multiple_activities,
} from "./utils/http";
import { DataGrid } from "@mui/x-data-grid";

import { COLUMN_ITINERRARY_MESSTOOL } from "./utils/constDispatch";
import AppBarSearchBox from "./components/SearchBox";

export default function MessTool({}) {
  const [search_text, set_search_text] = useState("");
  const [activities, set_activities] = useState(null);
  const [data_filter, set_data_filter] = useState(null);
  const [selected_id, set_selected_id] = useState([]);
  const [message, set_message] = useState("");

  async function get_data_activities() {
    API_get_activities_simple((data) => {
      if (data.success) {
        set_activities(data.data);
        set_data_filter(data.data);
      }
    });
  }

  async function apply_message_for_multiple_activities() {
    let array_id = [];
    selected_id.map((x) => array_id.push(x));
    let data = {
      array_id: array_id,
      message_tool: message,
    };

    API_apply_message_for_multiple_activities(data, (data) => {
      get_data_activities();
      set_message("");
    });
  }

  useEffect(() => {
    get_data_activities();
  }, []);

  const handle_search = (search_text) => {
    if (search_text == "") {
      set_data_filter(activities);
    } else {
      let data_tmp = activities.filter((x) => {
        let str = x.label + x.accomodation_code + x.created_at;
        str = str.replace(/\W/g, "").toLocaleLowerCase();
        let str_search = search_text.replace(/\W/g, "").toLocaleLowerCase();
        return str.includes(str_search);
      });

      set_data_filter(data_tmp);
    }
  };

  if (activities != null && data_filter != null) {
    return (
      <Box style={{ flexDirection: "column", display: "flex" }}>
        <AppBarSearchBox
          title="Itinerary"
          value={search_text}
          onChange={(e) => {
            if (e.target.value == "") {
              handle_search("");
              set_selected_id(null);
            }
            set_search_text(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handle_search(search_text);
              set_selected_id(null);
            }
          }}
        />

        <Box
          sx={{
            height: "100%",
            width: "90%",
            paddingLeft: 5,
            paddingRight: 5,
          }}
        >
          <Typography variant="h6">Message CODE</Typography>
          <Typography variant="body2">CODE_CUSTOMER_NAME</Typography>
          <Typography variant="body2">CODE_CUSTOMER_PHONE</Typography>

          <TextField
            id="message"
            label="message"
            value={message}
            fullWidth
            multiline
            minRows={3}
            style={{ marginBottom: 10, marginTop: 20 }}
            onChange={(e) => set_message(e.target.value)}
          />
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              variant="contained"
              onClick={() => get_data_activities()}
              style={{ marginLeft: 10 }}
            >
              Refresh
            </Button>
            {selected_id && selected_id.length > 0 && (
              <Button
                variant="contained"
                onClick={() => apply_message_for_multiple_activities()}
              >
                Apply message for {selected_id.length} activities
              </Button>
            )}
          </Box>
          <DataGrid
            checkboxSelection
            onRowSelectionModelChange={(e) => set_selected_id(e)}
            getRowId={(item) => item._id}
            rows={data_filter}
            columns={COLUMN_ITINERRARY_MESSTOOL}
            initialState={{
              pagination: { paginationModel: { pageSize: 20 } },
            }}
            density="compact"
            pageSizeOptions={[5, 10, 20]}
          />
        </Box>
      </Box>
    );
  } else {
    return (
      <Box sx={{ width: "100%", marginTop: 10 }}>
        <LinearProgress />
      </Box>
    );
  }
}
